import React, { useEffect, useState } from "react";
import "./navbar.css";
import logo from "../../Media/logo.png";
import { Button } from "react-bootstrap";
import { Close, Menu } from "@mui/icons-material";
import db, { auth } from "../../Firebase/config";
import { doc, getDoc } from "firebase/firestore";
import { Link, useNavigate } from "react-router-dom";
import { signOut } from "firebase/auth";
import { yellow } from "@mui/material/colors";

const Navbar = () => {
  const [toggleMenu, setToggleMenu] = useState(false);
  const [user, setUser] = useState();

  let navigate = useNavigate();

  useEffect(() => {
    getDoc(doc(db, "users", auth.currentUser.uid)).then((docSnap) => {
      if (docSnap.exists) {
        setUser(docSnap.data());
      }
    });
  }, []);

  const handleSignout = async () => {
    await signOut(auth);
    navigate("/login");
  };

  return (
    <div className="navbar">
      <div className="navbar-smallscreen">
        <Menu style={{ color: "yellow" }} onClick={() => setToggleMenu(true)} />
        {toggleMenu && (
          <div className="navbar-smallscreen_overlay">
            <Close
              onClick={() => setToggleMenu(false)}
              className="overlay__close"
            />
            <div className="navbar-smallscreen-profile">
              <img
                src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ86HlhVK5rQb3dDNo0DhqhHWP3lhomenQEY-e19LXMg6orlGWzsI3nNLx6KB-6Ai2cQdU&usqp=CAU"
                alt="profile-pic"
              />
              <h3>{user?.name}</h3>
            </div>
            <div className="navbar-smallscreen-links">
              <div className="navbar-smallscreen-link">
                <Link to="/dashboard">History Of Complaints</Link>
              </div>
              <div className="navbar-smallscreen-link">
                <Link to="/complaint">Make Complaint</Link>
              </div>
            </div>
            <div className="navbar-smallscreen-logout">
              <Button
                variant="danger"
                onClick={handleSignout}
                style={{ marginTop: 10 }}
              >
                LOGOUT
              </Button>
            </div>
          </div>
        )}
      </div>

      <div className="navbar-left"></div>
      <div className="navbar-right">
        <h4>Ayawaso West City App</h4>
        <img src={logo} />
      </div>
    </div>
  );
};

export default Navbar;
